import { typographier } from "../../utils/typography/typographier";

function cardSenary({ session }) {
  return (
    <div className="cardSenary">
      <div className="cardSenary-containerContains">
        <div className="cardSenary-containerContains-containerImg">
          <picture>
            <source media="(min-width: 1024px)" srcSet={session.coverDesktopXl} type="image/webp" />
            <source media="(min-width: 440px)" srcSet={session.coverTablette} type="image/webp" />
            <img src={session.coverMobile} alt={session.alt} />
          </picture>
        </div>

        <div className="cardSenary-containerContains-descriptions">
          <div className="cardSenary-containerContains-descriptions-containerTitle">
            <h2 className="cardSenary-containerContains-descriptions-containerTitle-title1">
              {session.title}
            </h2>
          </div>
          <div className="cardSenary-containerContains-descriptions-containerParagrapheFirst">
            <p className="cardSenary-containerContains-descriptions-containerParagraphes">
              {typographier(session.paragraphe1)}
            </p>
          </div>
          <div className="cardSenary-containerContains-descriptions-containerParagraphe">
            <p className="cardSenary-containerContains-descriptions-containerParagraphes">
              {typographier(session.paragraphe2)}
            </p>
          </div>
          <div className="cardSenary-containerContains-descriptions-containerParagraphe">
            <p className="cardSenary-containerContains-descriptions-containerParagraphes">
              {typographier(session.paragraphe3)}
            </p>
          </div>
        </div>
      </div>
      <div className="cardSenary-containerBackground"></div>
    </div>
  );
}

export default cardSenary;
